/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getGame = /* GraphQL */ `
  query GetGame($id: ID!) {
    getGame(id: $id) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listGames = /* GraphQL */ `
  query ListGames(
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGames(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getRoom = /* GraphQL */ `
  query GetRoom($id: ID!) {
    getRoom(id: $id) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      owner
      updatedAt
    }
  }
`;
export const listRooms = /* GraphQL */ `
  query ListRooms(
    $filter: ModelRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRooms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        gameId
        gameTitle
        gameDescription
        fieldTags
        isCopiedGame
        game {
          id
          title
          description
          fieldTags
          createdAt
          updatedAt
          owner
        }
        characters {
          id
          name
          editor
        }
        cards {
          id
          tag
          isDeal
          faceUpString
          faceDownString
          editor
          isAllOpen
          isGroupOpen
        }
        groups {
          id
          members
        }
        guests {
          nextToken
        }
        requests {
          nextToken
        }
        editors
        createdAt
        owner
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGuest = /* GraphQL */ `
  query GetGuest($id: ID!) {
    getGuest(id: $id) {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const listGuests = /* GraphQL */ `
  query ListGuests(
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        roomId
        userName
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRequest = /* GraphQL */ `
  query GetRequest($id: ID!) {
    getRequest(id: $id) {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
export const listRequests = /* GraphQL */ `
  query ListRequests(
    $filter: ModelRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        roomId
        userName
        name
        isAccept
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
